<!-- P13S0 Component - Foreign Partner's Distributive Share -->
<div class="f1065-k2-container">

  <!-- INITIAL LOADING STATE - shown when waiting for filter selection -->
  @if (loadingData) {
<div class="gg-loader">
    <div class="gg-loader-text">
      <img src="assets/img/arrow-filter-sm.png" alt="">
    </div>
  </div>
}

  <!-- MAIN CONTENT - shown after initialization -->
  @if (!loadingData) {
<div>
    
    <!-- FORM LOADER - shown while fetching data after filter selection -->
    @if (showLoader) {
<div class="form-loader">
      <div class="css-spinner"></div>
    </div>
}

    <!-- FORM CONTENT -->
    @if (!showLoader) {
<div>
    <!-- Section Header -->
    <p class="h5 section-header">
      <b>{{ sectionHeader }}</b>
    </p>

    <!-- Main Table -->
    <div class="table-responsive">
      <table class="table table-striped blue tbl-cus-width">
        <thead>
          <tr align="center">
            @if (showErrCol) {
<th style="width: 200px;">Error</th>
}
            <th class="hd-sno" style="text-align: center">Line</th>
            <th style="text-align: center">Description</th>
            @for (cols of colHeaderData | orderBy:'COL_PRIORITY'; track $index) {
<th
                style="width:122px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of groupedFormLines | filterBy:'IS_DISPLAY':'Y' | orderBy:['LINE_ORDER', 'SNO']; track trackByLine($index, x)) {
<tr>
            <!-- Error Column -->
            @if (showErrCol) {
<td class="err-col">
              <div [ngClass]="x.ERR_MSG && x.ERR_MSG.length > 0 ? 'err-cell-yes' : 'err-cell-no'"
                   [innerHTML]="x.ERR_MSG">
              </div>
            </td>
}

            <!-- Line Number with Add/Delete buttons -->
            <td style="font-weight:bold; white-space: nowrap; padding-right: 5px; text-align: right;">
              @if (x.SNO === 0 && x.IS_LINE_MULTI === 'Y') {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-plus-circle color-green"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              @if (x.SNO > 0) {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-minus-circle color-red"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              @if (x.SNO === 0) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description -->
            <td>
              <p>
                {{ x.SNO === 0 ? x.LINE_DESC : '' }}
                @if (x.IS_MANDATORY === 'Y') {
<span>*</span>
}
                @if (x.IS_PREF_MANDATORY === 'Y') {
<span style="vertical-align: super;">+</span>
}
              </p>
            </td>

            <!-- Data Cells -->
            @for (amts of x.items | orderBy:'COL_ORDER'; track trackByItem($index, amts)) {
<td
                style="height: 30px; width:122px; text-align: right;">
              
              <!-- Hidden ADJ_KEY -->
              <input type="hidden" [(ngModel)]="amts.ADJ_KEY">

              <!-- NUMERIC (regular) - excludes B1 which needs decimal input -->
              @if (amts.LINE_COMP === 'NUMERIC' && x.LINE_NO !== 'B1') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [readonly]="isLastNumericColumn(x.items, amts)"
                     onlyIntegersWithLength
                     style="text-align: right;"
                     (ngModelChange)="calcTotalsCol(x.items)">
}

              <!-- NUMERIC (B1 only) - allows decimal values between 0 and 1 -->
              @if (amts.LINE_COMP === 'NUMERIC' && x.LINE_NO === 'B1') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     onlyDigitsDecimalWithLength
                     [decimalDigits]="10"
                     style="text-align: right;">
}

              <!-- NUMERIC_INT -->
              @if (amts.LINE_COMP === 'NUMERIC_INT') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     onlyIntegersWithLength
                     style="text-align: right;">
}

              <!-- TEXT -->
              @if (amts.LINE_COMP === 'TEXT') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [maxlength]="amts.MAX_LENGTH || 1000"
                     style="text-align: right;">
}

              <!-- CHECK BOX -->
              @if (amts.LINE_COMP === 'CHK_BX') {
<input
                     type="checkbox"
                     [ngModel]="amts.CELL_VALUE === 'X'"
                     (ngModelChange)="amts.CELL_VALUE = $event ? 'X' : ''"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     class="lg-chk">
}

              <!-- DATE: ENABLED -->
              @if (amts.LINE_COMP === 'DATE' && amts.IS_ENABLED !== 'N') {
<div class="input-group">
                <input type="date"
                       style="font-size: 11px;"
                       class="form-control min-ele-wid"
                       [ngClass]="{
                         'custom-error': amts.IS_ERROR === 'Y',
                         'custom-textbox': amts.IS_ENABLED === 'Y' || amts.IS_ENABLED === 'Z'
                       }"
                       [ngModel]="amts.CELL_VALUE | date:'yyyy-MM-dd'"
                       (ngModelChange)="onDateChange(amts, $event)"
                       placeholder="yyyy-mm-dd">
              </div>
}

              <!-- DATE: DISABLED -->
              @if (amts.LINE_COMP === 'DATE' && amts.IS_ENABLED === 'N') {
<div class="input-group">
                <input type="date"
                       style="font-size: 11px;"
                       class="form-control min-ele-wid"
                       [ngModel]="amts.CELL_VALUE | date:'yyyy-MM-dd'"
                       disabled
                       placeholder="yyyy-mm-dd">
              </div>
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- Buttons -->
    @if (isAdmin) {
<div class="k2-buttons-container">
      <button class="save-button" type="button" (click)="saveData()" [disabled]="isSaveClicked">Save</button>
      <button class="reset-button" type="button" (click)="reset()" [disabled]="!isAdmin">Reset</button>
    </div>
}
    </div>
} <!-- closes content -->
  </div>
} <!-- closes !loadingData -->
</div> <!-- closes f1065-k2-container -->

<!-- Confirmation Modal -->
@if (showConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmSave(true)"
    (cancelled)="onConfirmSave(false)"
    (closed)="onConfirmSave(false)">
  </gtw-confirmation-modal>
</div>
}
